var React = require('react');

function PauseIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.761719","y":"0.695312","width":"1.82609","height":"8.21739","fill":"#242424","key":0}),React.createElement("rect",{"x":"4.41406","y":"0.695312","width":"1.82609","height":"8.21739","fill":"#242424","key":1})]);
}

PauseIcon.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 7 5","fill":"none"};

module.exports = PauseIcon;

PauseIcon.default = PauseIcon;
